import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import CardEditor from "@/pages/CardEditor";
import CardView from "@/pages/CardView";
import AISpecialistBuild from "@/pages/AISpecialistBuild";
import Admin from "@/pages/Admin";
import Store from "@/pages/Store";
import Plan from "@/pages/Plan";
import Activate from "@/pages/Activate";
import WarRoom from "@/pages/WarRoom";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Support from "@/pages/Support";
import SupportDashboard from "@/pages/SupportDashboard";

const ADMIN_SUPPORT_ROLES = ["admin", "support"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/store" element={<Store />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/support" element={<Support />} />
            <Route
              path="/support/admin"
              element={
                <ProtectedRoute roles={ADMIN_SUPPORT_ROLES}>
                  <SupportDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plan"
              element={
                <ProtectedRoute>
                  <Plan />
                </ProtectedRoute>
              }
            />
            <Route
              path="/activate"
              element={
                <ProtectedRoute>
                  <Activate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/warroom"
              element={
                <ProtectedRoute>
                  <WarRoom />
                </ProtectedRoute>
              }
            />
            <Route
              path="/build"
              element={
                <ProtectedRoute>
                  <AISpecialistBuild />
                </ProtectedRoute>
              }
            />
            <Route
              path="/card/:id"
              element={
                <ProtectedRoute>
                  <CardEditor />
                </ProtectedRoute>
              }
            />
            <Route
              path="/card/:id/view"
              element={
                <ProtectedRoute>
                  <CardView />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={ADMIN_SUPPORT_ROLES}>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Toaster position="top-right" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
